(function () {
  const modal = document.getElementById("rbp-modal");
  if (!modal) return;

  const form = document.getElementById("rbp-form");
  const iframe = document.getElementById("rbp-target");

  const formWrap = document.getElementById("rbp-form-wrap");
  const success = document.getElementById("rbp-success");
  const captcha = document.getElementById("rbp-captcha");
  const errorBox = document.getElementById("rbp-error");

  const productField = document.getElementById("rbp-product");
  const urlField = document.getElementById("rbp-url");

  if (!form || !iframe || !productField || !urlField) return;

  let submitting = false;
  let openedAt = 0;

  const show = (el) => el && (el.style.display = "");
  const hide = (el) => el && (el.style.display = "none");

  function resetStates() {
    show(formWrap);
    show(form);
    hide(success);
    hide(captcha);
    hide(errorBox);

    const submitBtn = form.querySelector(".rbp-submit");
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit Request";
    }
  }

  function openModal(title, url) {
    resetStates();

    productField.value = title || "";
    urlField.value = url || window.location.href;

    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    openedAt = Date.now();
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  // OPEN from any button
  document.addEventListener("click", function (e) {
    const trigger = e.target.closest(".rbp-trigger,[data-request-best-price]");
    if (!trigger) return;

    e.preventDefault();

    const title =
      trigger.getAttribute("data-rbp-product") ||
      trigger.getAttribute("data-product-title") ||
      "";

    const url =
      trigger.getAttribute("data-rbp-url") ||
      trigger.getAttribute("data-product-url") ||
      "";

    openModal(title, url);
  });

  // CLOSE: overlay / close button
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-rbp-close]") || e.target.classList.contains("rbp-overlay")) {
      e.preventDefault();
      closeModal();
    }
  });

  // ESC close
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeModal();
  });

  // SUBMIT state
  form.addEventListener("submit", function () {
    submitting = true;

    const submitBtn = form.querySelector(".rbp-submit");
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending...";
    }
  });

  // IFRAME result
  iframe.addEventListener("load", function () {
    // Ignore iframe loads not caused by a form submit
    if (!submitting) return;

    // Guard against weird early loads right after opening
    if (Date.now() - openedAt < 200) return;

    submitting = false;

    let html = "";
    try {
      html = iframe.contentDocument?.documentElement?.innerHTML || "";
    } catch (err) {
      // If we can't read the iframe (rare), treat as success UX
      html = "";
    }

    const looksLikeCaptcha =
      /g-recaptcha|recaptcha|captcha/i.test(html) ||
      /verify you are human/i.test(html) ||
      /challenge/i.test(html);

    // Shopify contact form errors often render a list with "errors"
    const looksLikeError =
      /class="form__message"/i.test(html) ||
      /errors/i.test(html);

    if (looksLikeCaptcha) {
      hide(formWrap);
      hide(form);
      hide(success);
      hide(errorBox);
      show(captcha);
      return;
    }

    if (looksLikeError) {
      const submitBtn = form.querySelector(".rbp-submit");
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit Request";
      }
      show(errorBox);
      return;
    }

    // SUCCESS
    hide(formWrap);
    hide(form);
    hide(captcha);
    hide(errorBox);
    show(success);

    setTimeout(closeModal, 2200);
  });
})();
